// 获取多重搜索后的列表
export const GETMULTISEARCHLIST = 'get-multi-search-list'
// 获取新闻搜索
export const GETNEWSSEARCHLIST = 'get-news-search-list'
// 获取快讯搜索
export const GETLIVESEARCHLIST = 'get-live-search-list'
